import React, { useState } from 'react';
import DashboardLayout from '../components/Layout/DashboardLayout';
import PanelList from '../components/Panels/PanelList';
import CreatePanelModal from '../components/Panels/CreatePanelModal';
import { usePanels } from '../hooks/usePanels';
import { panelsApi } from '../api';
import { FiPlus, FiRefreshCw } from 'react-icons/fi';
import toast from 'react-hot-toast';

export default function PanelsPage() {
  const { panels, loading, refetch } = usePanels();
  const [showCreate, setShowCreate] = useState(false);

  const handleCreate = async (data) => {
    try {
      await panelsApi.create(data);
      toast.success('Panel created');
      setShowCreate(false);
      refetch();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to create panel');
    }
  };

  return (
    <DashboardLayout>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground">Child Panels</h1>
          <p className="text-muted-foreground text-sm">
            Manage {panels.length} child panels and their admin accounts
          </p>
        </div>
        <div className="flex gap-2">
          <button onClick={async () => {
              try {
                toast.loading('Syncing stats...', { id: 'syncStats' });
                await panelsApi.syncStats();
                toast.success('Stats synced', { id: 'syncStats' });
                refetch();
              } catch (err) {
                toast.error(err.response?.data?.error || 'Failed to sync stats', { id: 'syncStats' });
              }
            }}
            className="h-10 px-4 py-2 rounded-md bg-secondary hover:bg-secondary/90 text-secondary-foreground text-sm font-medium transition-colors flex items-center gap-2">
            <FiRefreshCw size={16} /> Sync Stats
          </button>
          <button onClick={() => setShowCreate(true)}
            className="h-10 px-4 py-2 rounded-md bg-primary hover:bg-primary/90 text-primary-foreground text-sm font-medium transition-colors flex items-center gap-2">
            <FiPlus size={16} /> Create Panel
          </button>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin"></div>
        </div>
      ) : (
        <PanelList panels={panels} onRefresh={refetch} />
      )}

      {showCreate && (
        <CreatePanelModal onClose={() => setShowCreate(false)} onCreate={handleCreate} />
      )}
    </DashboardLayout>
  );
}
